import { useState } from 'react';

export const useRecordingError = () => {
  const [error, setError] = useState('');

  const clearError = () => {
    setError('');
  };

  const handleError = (message, originalError = null) => {
    if (originalError) {
      console.error(message, originalError);
    } else {
      console.error(message);
    }
    setError(message);
  };

  return {
    error,
    setError,
    clearError,
    handleError
  };
};